import React from 'react';
import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import moment from 'moment';
import {useDispatch} from 'react-redux';
import {getStrokePosts, deleteStrokePost} from '../../../actions/strokeposts';
import {Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: 'purple',
  },
}));



const StrokePost = ({post, setCurrentId, pageNumber}) =>{
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('profile'));
  const [expanded, setExpanded] = React.useState(false);

  
  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar} >
          {post.name[0]}{post.name.split(" ")[1][0]}
          </Avatar> 
        }
        action={
          <IconButton aria-label="settings">
            {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
            <div  className = {classes.overlay2}>
                <Button style = {{color : 'black'}}  size = "small" onClick = {()=> setCurrentId(post._id)}>
                    <MoreHorizIcon  fontSize = "default" />    
                </Button>
            </div>
            )}
          </IconButton>
        }
        title ={post.prediction}
        subheader= {moment(post.createdAt).fromNow()}
        >  
      </CardHeader>
      <CardMedia
        className={classes.media}
        image={post.prediction === "High Chance"? "https://thailand-business-supplement.com/wp-content/uploads/2017/03/Fotolia_60962332_Subscription_Monthly_M-1170x780.jpg":  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyjZjW8iAiwUZFipdz2vkCuJt9QvUx-PXdH1vvMOO9CTla37kzG4r-jNZeMusvxgUAI8w&usqp=CAU"}
        title={post.prediction}
      />
      <CardContent>
        <Typography variant="body2" color="textPrimary" component="p">
          Age: {post.age}    
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Gender: {post.sex === "1" ? "Male" : "Female" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Polyuria: {post.hypertension === "1" ? "Yes" : "No" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Heart Disease: {post.heartDisease === "1"? "Yes": "No"}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          BMI: {post.bmi}  
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Glucose Level: {post.glucose} 
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Work Type: {post.workType === "0" ? "Private" : 
          (post.workType === "1" ? "Self-employed" : 
          (post.workType === "2"? "Govt. job" : 
          (post.workType === "3" ? "Children" : "Never Worked")))}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Possibility: {post.probability}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
        <div>
          <Grid
            item
            container
            direction="row"
            justify="flex-end"
          >
            <Button size="small" color="secondary" onClick={() => {
              dispatch(deleteStrokePost(post._id))
              dispatch(getStrokePosts(pageNumber))
              dispatch(getStrokePosts(pageNumber))}}>
              <DeleteIcon fontSize="small" /> 
              Delete
            </Button>
          </Grid>
        </div>
        )} 
      </CardActions>
    </Card>
  );
};

export default StrokePost;

